import { MaskInput } from "maska";

const iconPasswords = document.querySelectorAll('.js--togglePassword');
const passwords = document.querySelectorAll('.js--passwordInput');

if (iconPasswords.length && passwords.length) {
  iconPasswords.forEach((icon, index) => {
    icon.addEventListener('click', function() {
      let password = passwords[index];
      if (password.type === "password") {
        password.type = "text";
        icon.classList.add("active");
      } else {
        password.type = "password";
        icon.classList.remove("active");
      }
    });
  });
}

function togglePasswordsVisibility() {
  const iconPasswords = document.querySelectorAll('.js--togglePassword');
  const passwords = document.querySelectorAll('.js--passwordInput');

  if (iconPasswords.length && passwords.length) {
    iconPasswords.forEach((icon, index) => {
      icon.addEventListener('click', function() {
        let password = passwords[index];
        if (password.type === "password") {
          password.type = "text";
          icon.classList.add("active");
        } else {
          password.type = "password";
          icon.classList.remove("active");
        }
      });
    });
  }
}

window.togglePasswordsVisibility = togglePasswordsVisibility;

let phoneInputs = document.querySelectorAll('.js--phoneInput');
let dateInputs = document.querySelectorAll('.js--dateInput');
let erdpouInputs = document.querySelectorAll('.js--erdpou');
const phoneCode = '+380';

if (phoneInputs.length > 0) {
  phoneInputs.forEach((phoneInput) => {
    new MaskInput(phoneInput, { mask: '+380 ## ### ## ##' });

    phoneInput.addEventListener('focus', () => {
      if (!phoneInput.value.startsWith(phoneCode)) {
        phoneInput.value = phoneCode + phoneInput.value;
      }
    });

    phoneInput.addEventListener('blur', () => {
      if (phoneInput.value === phoneCode) {
        phoneInput.value = '';
      }
    });
  });
}

window.PhoneMask = {
  init: function (selector, phoneCode) {
    const phoneInputs = document.querySelectorAll(selector);
    if (phoneInputs.length > 0) {
      phoneInputs.forEach((phoneInput) => {
        new MaskInput(phoneInput, { mask: '+380 ## ### ## ##' });

        phoneInput.addEventListener('focus', () => {
          if (!phoneInput.value.startsWith(phoneCode)) {
            phoneInput.value = phoneCode + phoneInput.value;
          }
        });

        phoneInput.addEventListener('blur', () => {
          if (phoneInput.value === phoneCode) {
            phoneInput.value = '';
          }
        });
      });
    }
  }
};

if (dateInputs.length > 0) {
  dateInputs.forEach((dateInput) => {
    new MaskInput(dateInput, { mask: '##.##.####' });
  });
}
if (erdpouInputs.length > 0) {
  erdpouInputs.forEach((erdpouInput) => {
    new MaskInput(erdpouInput, { mask: '##########' });
  });
}

